import { API } from "../../../../utils/api";

export async function getInsuranceAPI(modelType) {
  return (await API.get(`v2/lease/insurance?modelType=${modelType}`)).data
}